import { DataModel } from "common/models/utility-models/base-model";

export class ResultReportsModel extends DataModel {
    selectedBatch: string = '';
    selectedRegion: string = '';
    selectedState: string = '';
    selectedBranch: string = '';
    selectedGender: string = '';
    selectedStatus: string = '';
    selectedScore: string = '';
    selectedKT: string = '';
    selectedSem: string = '';
    selectedUploadFilter: string = '';
}